var jsonArray = [];
var data;
var sortedData = ['Home','Manage Roles','Manage Accounts','Manage Museum','Manage Schools','Manage Teachers','General Settings','Manage Booking','Reports'];
var sortedArray = [];
const mcHome = {
    name: 'Home',
    url: '/MC',
};
const mfdHome = {
    name: 'Home',
    url: '/MFD',
};
const mfHome = {
    name: 'Home',
    url: '/MF',
};
const maHome = {
    name: 'Home',
    url: '/MA',
};
const saHome = {
    name: 'Home',
    url: '/SA',
};


const mcManageBooking = {
    name: 'Manage Booking',
    url: '/managebookingmc',
};
const mfdManageBooking = {
    name: 'Manage Booking',
    url: '/managebookingmfd',
};

const mfManageBooking = {
    name: 'Manage Booking',
    url: '/managebookingmf',
};


const manageRole = {
    name: 'Manage Roles',
    url: '/manageroles',
};
const manageAccount = {
    name: 'Manage Accounts',
    url: '/manageaccounts',
    children: [
        // {
        //     name: 'Account Requests',
        //     url: '/inprogress',
        // },
        {
            name: 'Staff Accounts',
            url: '/manageaccounts',
        },
    ],
};
const bookingReport = {

    name: 'Reports',
    url: '/reports',
    // children: [
    //     {
    //         name: 'Booking Report',
    //         url: '/reportssa',
    //     }
    // ],
};

/* const saReport = {

    name: 'Reports',
    url: '/inprogress',
    children: [
        {
            name: 'Booking Report',
            url: '/inprogress',
        },
        {
            name: 'User Account Reports',
            url: '/inprogress',
        }
    ],
}; */
const saManageMuseums = {
    name: 'Manage Museum',
    url: '/inprogress',
    children: [
        {
            name: 'List of Museums',
            url: '/listofmuseums',
        },
        {
            name: 'Programmes',
            url: '/programmes',
        },
    ],
};
const manageMuseums = {
    name: 'Manage Museum',
    url: '/inprogress',
    children: [
        {
            name: 'Programmes',
            url: '/programmes',
        },
        {
            name: 'Museum Settings',
            url: '/museumsettings',
        },
    ],
};
/* const manageSchool = {
    name: 'Manage Schools',
    url: '/inprogress',
}; */
const manageTeachers = {
    name: 'Manage Teachers',
    url: '/inprogress',
    children: [
        {
            name: 'Account Requests',
            url: '/accountrequests',
        },
        {
            name: 'Teacher Accounts',
            url: '/teacheraccounts',
        },
    ],
};
const generalSetting = {
    name: 'General Settings',
    url: '/inprogress',
    children: [
        {
            name: 'Schedule Ticker',
            url: '/scheduleticker',
        },
        // {
        //     name: 'Public Holidays',
        //     url: '/publicHolidays',
        // },
    ],
};
const saGeneralSetting = {
    name: 'General Settings',
    url: '/inprogress',
    children: [
     /*    {
            name: 'Sessions',
            url: '/inprogress',
        },
        {
            name: 'Security',
            url: '/inprogress',
        }, */
        {
            name: 'Banners',
            url: '/banners',
        },
        // {
        //     name: 'Public Holidays',
        //     url: '/publicHolidays',
        // }

    ],
};

let localUser = JSON.parse(localStorage.getItem('user'));
if(localUser && localUser.Roles[0].RoleId && localStorage.getItem('UserRoleType')){
    let userDetails;
    localUser.Roles.forEach((val)=>{
        if(localStorage.getItem('UserRoleType')===val.RoleId)
            userDetails = val;

    })
    const RoleType = localStorage.getItem('UserRoleType');
    let item = userDetails&&userDetails.PrivilegeList; //Featching PrivilegeList

    let accessedItem = item&&item.filter(function(items) {  //Filter the item those have permission to access
        return items.IsChecked===true;
    });
    accessedItem&&accessedItem.forEach(val=>{    //Assigne dynamic role for specific user
        if(RoleType==="SA"){
            if(val.PrivilegeName==="Manage Accounts") jsonArray.push(manageAccount);
            if(val.PrivilegeName==="Generate Booking Reports") jsonArray.push(bookingReport);
            if(val.PrivilegeName==="Manage Museum Settings") jsonArray.push(saManageMuseums);
        }
        if(RoleType==="MA"){
            //if(val.PrivilegeName==="Manage Bookings") jsonArray.push(manageBooking);
            if(val.PrivilegeName==="Manage Accounts") jsonArray.push(manageAccount);
            if(val.PrivilegeName==="Manage Museum Settings") jsonArray.push(manageMuseums);
            if(val.PrivilegeName==="Generate Booking Reports") jsonArray.push(bookingReport);
        }
        if(RoleType==="MC"){
            if(val.PrivilegeName==="Manage Museum Settings") jsonArray.push(manageMuseums);
            if(val.PrivilegeName==="Generate Booking Reports") jsonArray.push(bookingReport);
            // if(val.PrivilegeName==="Manage Bookings") jsonArray.push(manageBooking);
            if(val.PrivilegeName==="Manage Bookings") jsonArray.push(mcManageBooking);
        }
        if(RoleType==="MF"){

            if(val.PrivilegeName==="Manage Bookings") jsonArray.push(mfManageBooking);
            if(val.PrivilegeName==="Generate Booking Reports") jsonArray.push(bookingReport);

        }
        if(RoleType==="MFD"){
            if(val.PrivilegeName==="Manage Museum Settings") jsonArray.push(manageMuseums);
            if(val.PrivilegeName==="Generate Booking Reports") jsonArray.push(bookingReport);
            // if(val.PrivilegeName==="Manage Bookings") jsonArray.push(manageBooking);
            if(val.PrivilegeName==="Manage Bookings") jsonArray.push(mfdManageBooking);
        }
    })
    //Assigne static role for specific user
    if(RoleType==="SA"){
        jsonArray.push(manageRole); // Static
        //jsonArray.push(manageSchool); // Static
        jsonArray.push(manageTeachers);// Static
        jsonArray.push(saGeneralSetting);// Static
        jsonArray.push(saHome);// Static

    }
    if(RoleType==="MA"){
        jsonArray.push(manageRole); // Static
        jsonArray.push(generalSetting);// Static
        jsonArray.push(maHome);// Static

    }
    if(RoleType==="MC"){
        jsonArray.push(generalSetting);// Static
        jsonArray.push(mcHome);// Static

    }
    if(RoleType==="MFD"){
        jsonArray.push(mfdHome);// Static

    }
    if(RoleType==="MF"){
        jsonArray.push(mfHome);// Static

    }
//Sorting the sidebar array
function  checkIsexist(data){
    jsonArray.forEach(val=>{
        if(data===val.name){
            sortedArray.push(val)
        }
    })
}
sortedData.forEach(val=>{
   checkIsexist(val);
})
}
data = {items:sortedArray};
export default data;

